import { initialDataConfigConcept } from './state';

/**
 * Restablecer la información de la configuración del concepto.
 * 
 * @param Object state 
 */
export function resetConfigConcept(state) {
    state.configConcept = initialDataConfigConcept();
}

/**
 * Actualizar la información de la configuración del concepto.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setConfigConcept(state, nextState) {
    state.configConcept = nextState;
}
